import ApiService from "./../api.service";
import JwtService from "./../jwt.service";
import router from "../../router";
import store from ".";

const state = {
    notFound: false,
    userName: ''
};

const getters = {
    notFound(state){
        return state.notFound;
    },
    userName(state){
        return state.userName;
    }
};

const actions = {
    login(context, payload) {
        store.dispatch('setLoading', true);
        return ApiService.post("/api/Account/Login", {
            UserName: payload.username,
            Password: payload.password,
            RememberMe: payload.remamberMe
        }).then(({ data }) => {
            if(!!data){
                context.commit('SET_AUTH', data);
            } else {
                context.commit('NOT_FOUND');
            }
        });
    },
    logout(context) {
        context.commit('LOG_OUT');
    },
    setUserName(context, payload){
        context.commit("SET_USER_NAME", payload);
    }
};

const mutations = {
    SET_AUTH(state, user) {
        JwtService.saveToken(user.token);
        ApiService.setHeader();
        switch(user.roles[0]) {
            case "Shop" : router.push('/shop');
            break;
            case "Offer" : router.push('/ad/1/-1');
            break;
            case "Contact" : router.push('/contact/customers');
            break;
            case "Subscription" : router.push('/subscription/-1');
            break;
            default: router.push('/dashboard')
            break;
        }
        state.notFound = false;  
    },
    NOT_FOUND(state){
        state.notFound = true; 
        store.dispatch('setLoading', false);
    },
    SET_USER_NAME(state, payload){
        state.userName = payload;
    },
    LOG_OUT(state) {
        JwtService.destroyToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};